import { useState, useCallback, useEffect } from 'react';
/**
 * Return the visual viewport, and trigger a re-render when it changes.
 * @returns {VisualViewport} the visualViewport
 */
const useViewport = () => {
  const viewport = window.visualViewport;
  // The following is used to trigger a re-render.
  // eslint-disable-next-line no-unused-vars
  const [_, trigger] = useState({});
  const onChange = useCallback(() => trigger({}), []);
  useEffect(() => {
    window.addEventListener('resize', onChange);
    window.addEventListener('scroll', onChange);
    return () => {
      window.removeEventListener('resize', onChange);
      window.removeEventListener('scroll', onChange);
    };
  }, [onChange, viewport]);
  return viewport ?? {};
};

export default useViewport;
